module.exports = __webpack_public_path__ + "img/resolve_after_fr-ch.649790d9.svg";